import { useCallback } from 'react';
import { ErrorOutlineIcon } from 'tuui';
import { LoadingBar } from 'modules/campaigns/components';
import ThumbnailOverlay from 'modules/campaigns/modules/creative-creator/components/ThumbnailOverlay/ThumbnailOverlay';
import { THUMBNAIL_SOURCE_TYPES, VIDEO } from 'modules/campaigns/modules/creative-creator/config';
import { FormattedMessage, useIntl } from 'modules/taboola-common-frontend-modules/i18n';
import { ImageGallery } from '../../../../ImageGallery';
import styles from './galleryArea.module.scss';

const GalleryGenericError = (
    <div className={styles['error-message']}>
        <ErrorOutlineIcon />
        <FormattedMessage
            id="creative.editor.tab.aiGenerated.generic.errorMessage"
            defaultMessage="We were unable to process the request. Please try again."
        />
    </div>
);

export const GalleryArea = ({ shouldShowError, isLoading, videos, onSelectMedia }) => {
    const { formatMessage } = useIntl();
    const loadingMessage = formatMessage({
        id: 'creative.studio.generate.motion.loading.message',
        defaultMessage: 'Animation in progress, may take around 30 seconds...',
    });
    const selectMediaHandler = useCallback(
        (data, selected) => {
            onSelectMedia(() => ({ url: data.url }), {
                id: data.id,
                fallbackImageUrl: data.thumbnailUrl,
                fileType: VIDEO,
                mediaUploadSource: THUMBNAIL_SOURCE_TYPES.GEN_AI,
                selected,
            });
        },
        [onSelectMedia]
    );
    const videosCount = videos?.length || 0;
    const shouldShowGallery = videosCount > 0 && !shouldShowError;

    const banner = (
        <div className={styles['banner']}>
            <span className={styles['edit-label']}>
                <FormattedMessage
                    id="creative.editor.tab.aiGenerated.imageToMotion.select"
                    defaultMessage="Select motion"
                />
            </span>
        </div>
    );
    const renderOverlayComponent = () => (
        <ThumbnailOverlay banner={banner} isReloadButton={false} showXButton={false} />
    );

    return (
        <>
            {shouldShowError && GalleryGenericError}
            {isLoading && (
                <div className={styles['loading-bar']}>
                    <LoadingBar durationInSeconds={35} loadingMessage={loadingMessage} />
                </div>
            )}
            {shouldShowGallery && (
                <>
                    <div className={styles['motion-generated-title']}>
                        <FormattedMessage
                            id="creative.editor.tab.aiGenerated.imageToMotion.generated.assets"
                            defaultMessage="Generated assets ({videosCount})"
                            values={{ videosCount }}
                        />
                    </div>
                    <div className={styles['image-gallery-container']}>
                        <ImageGallery
                            recommendedImages={videos}
                            addImageHandler={selectMediaHandler}
                            renderOverlayComponent={renderOverlayComponent}
                            columnCount={3}
                            gap="12px 12px"
                            thumbnail={{ fileType: VIDEO }}
                        />
                    </div>
                </>
            )}
        </>
    );
};
